import {
  PriceDispatchTypes,
  Price_LOADING,
  Price_SUCCESS,
  Price_FAILED,
} from "../../actions/price/PriceActionType";

interface IDefaultState {
  loading: boolean;
  price?: any;
}

const defaultState: IDefaultState = {
  loading: false,
};

const PriceReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: PriceDispatchTypes
): IDefaultState => {
  switch (action.type) {
    case Price_FAILED:
      return {
        ...state,
        loading: false,
      };
    case Price_LOADING:
      return {
        ...state,
        loading: true,
      };
    case Price_SUCCESS:
      return {
        loading: false,
        price: { ...state.price, ...action.payload.price },
      };

    default:
      return state;
  }
};

export default PriceReducer;
